<template>
  <v-container
    fluid
    class="pa-0 ma-0"
  >
    <!-- Filter Criteria -->
    <v-card class="mb-2">
      <v-card-title class="pb-0 pt-2">
        <v-row class="ma-0 pa-0">
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="12"
          >
            <span class="body-1">Adjust weights</span>
          </v-col>
          <v-col
            cols="12"
            xs="2"
            md="1"
            class="pa-0"
            shrink
            style="width: 80px"
          >
            <v-text-field
              v-model="birthWt[0]"
              class="mt-0"
              :class="inputClass"
              hide-details
              single-line
              type="number"
              suffix="lbs"
              readonly
            />
          </v-col>
          <v-col
            cols="12"
            xs="8"
            md="10"
          >
            <v-range-slider
              v-model="birthWt"
              :max="130"
              :min="60"
              :step="5"
              class="ml-3 mr-3"
              label="Bwt"
              @change="loadData"
            />
          </v-col>
          <v-col
            cols="12"
            xs="2"
            md="1"
            class="pa-0"
            shrink
            style="width: 80px"
          >
            <v-text-field
              v-model="birthWt[1]"
              class="mt-0"
              :class="inputClass"
              hide-details
              single-line
              type="number"
              suffix="lbs"
              readonly
            />
          </v-col>

          <v-col
            cols="12"
            xs="2"
            md="1"
            class="pa-0"
            shrink
            style="width: 80px"
          >
            <v-text-field
              v-model="weanWt[0]"
              class="mt-0"
              :class="inputClass"
              hide-details
              single-line
              type="number"
              suffix="lbs"
              readonly
            />
          </v-col>
          <v-col
            cols="12"
            xs="8"
            md="10"
          >
            <v-range-slider
              v-model="weanWt"
              :max="800"
              :min="500"
              :step="10"
              class="ml-3 mr-3"
              label="Wwt"
              @change="loadData"
            />
          </v-col>
          <v-col
            cols="12"
            xs="2"
            md="1"
            class="pa-0"
            shrink
            style="width: 80px"
          >
            <v-text-field
              v-model="weanWt[1]"
              class="mt-0"
              :class="inputClass"
              hide-details
              single-line
              type="number"
              suffix="lbs"
              readonly
            />
          </v-col>

          <v-col
            cols="12"
            xs="2"
            md="1"
            class="pa-0"
            shrink
            style="width: 80px"
          >
            <v-text-field
              v-model="ylgWt[0]"
              class="mt-0"
              :class="inputClass"
              hide-details
              single-line
              type="number"
              suffix="lbs"
              readonly
            />
          </v-col>
          <v-col
            cols="12"
            xs="8"
            md="10"
          >
            <v-range-slider
              v-model="ylgWt"
              :max="1100"
              :min="800"
              :step="10"
              class="ml-3 mr-3"
              label="Ywt"
              @change="loadData"
            />
          </v-col>
          <v-col
            cols="12"
            xs="2"
            md="1"
            class="pa-0"
            shrink
            style="width: 80px"
          >
            <v-text-field
              v-model="ylgWt[1]"
              class="mt-0"
              :class="inputClass"
              hide-details
              single-line
              type="number"
              suffix="lbs"
              readonly
            />
          </v-col>
        </v-row>
      </v-card-title>
    </v-card>

    <!-- Results Table -->
    <v-data-table
      :headers="headers"
      :items="bulls"
      :loading="isSearching"
      :no-data-text="noDataText"
      item-key="calfIdValue"
      class="elevation-1"
    >
      <v-progress-linear
        v-slot:progress
        color="blue"
        indeterminate
      />

      <template v-slot:item.birthDate="{ item }">
        <span class="text-left">
          <span>{{ getSmallDate(item.birthDate) }}</span>
        </span>
      </template>

      <template v-slot:item.ylgDate="{ item }">
        <span class="text-left">
          <span>{{ getSmallDate(item.ylgDate) }}</span>
        </span>
      </template>

      <template v-slot:item.adgBwAdj="{ item }">
        <span class="text-right">
          <span>{{ getDecimalFormat(item.adgBwAdj) }}</span>
        </span>
      </template>

      <template v-slot:item.action="{ item }">
        <v-btn
          dark
          color="orange darken-3"
          @click="reserve(item)"
        >
          Reserve a bull like this
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import appService from '../app.service'

export default {
  name: 'BullFinderLiteContainer',
  data () {
    return {
      isSearching: false,
      bulls: [],
      birthWt: [80, 100],
      weanWt: [600, 700],
      ylgWt: [900, 1000],
      headers: [
        {
          text: 'YOB',
          value: 'birthYear',
          align: 'left',
          width: '5%'
        },
        {
          text: 'Breed',
          value: 'breed',
          align: 'left',
          width: '20%'
        },
        {
          text: 'Bull Id',
          value: 'calfIdValue',
          align: 'left',
          width: '10%'
        },
        {
          text: 'DOB',
          value: 'birthDate',
          align: 'center',
          width: '10%'
        },
        {
          text: 'Birth Wt',
          value: 'birthWt',
          align: 'right',
          width: '5%'
        },
        {
          text: 'Wean Wt',
          value: 'weanWt',
          align: 'right',
          width: '5%'
        },
        {
          text: 'Wean Age',
          value: 'weanAge',
          align: 'right',
          width: '5%'
        },
        {
          text: 'Ylg Date',
          value: 'ylgDate',
          align: 'center',
          width: '10%'
        },
        {
          text: 'Ylg Wt',
          value: 'ylgWt',
          align: 'right',
          width: '5%'
        },
        // {
        //   text: 'SC EBV',
        //   value: 'scEbv',
        //   align: 'right',
        //   width: '5%'
        // },
        // {
        //   text: 'BWT EBV',
        //   value: 'bwtEbv',
        //   align: 'right',
        //   width: '5%'
        // },
        // {
        //   text: 'YWT EBV',
        //   value: 'ywtEbv',
        //   align: 'right',
        //   width: '5%'
        // },
        {
          text: 'ADG B-W',
          value: 'adgBwAdj',
          align: 'right',
          width: '5%'
        },
        {
          text: 'Sel Idx',
          value: 'SelIdx',
          align: 'right',
          width: '5%'
        },
        {
          value: 'action',
          align: 'left',
          width: '15%',
          sortable: false
        }
      ]
    }
  },
  computed: {
    inputClass () {
      return {
        'v-input-md': this.$vuetify.breakpoint.name !== 'xs',
        'v-input-sm': this.$vuetify.breakpoint.name === 'xs'
      }
    },
    noDataText () {
      if (this.isSearching) return 'One moment...'

      return this.bulls.length === 0
        ? 'No bulls found'
        : ''
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      const self = this
      self.bulls = []
      self.isSearching = true
      appService.getPublicBullsByCriteria(self.birthWt[0], self.birthWt[1], self.weanWt[0], self.weanWt[1], self.ylgWt[0], self.ylgWt[1]).then(data => {
        self.bulls = data
        self.isSearching = false
      })
    },
    getFullDate (date) {
      if (date !== null) {
        if (date.length > 0) {
          return this.$moment(date).format('MM/DD/YYYY')
        }
      }
      return ''
    },
    getSmallDate (date) {
      if (date !== null) {
        if (date.length > 0) {
          return this.$moment(date).format('MM/DD')
        }
      }
      return ''
    },
    getDecimalFormat (x, decimals) {
      if (typeof x === 'undefined') return ''
      return x.toFixed(decimals)
    },
    reserve (item) {
      const self = this
      const index = self.bulls.indexOf(item)
      const breed = self.bulls[index].breed
      const uri = 'https://beefbooster.myshopify.com/products/'
      var breedStrain = ''
      var url = ''

      if (breed === 'Black Maternal') {
        breedStrain = breed + ' (M1)'
        url = uri + 'maternal-bulls?variant=5807380201515'
      } else if (breed === 'M2') {
        breedStrain = 'Maternal Bull (M2)'
        url = uri + 'maternal-bulls'
      } else if (breed === 'Heifer Bull') {
        breedStrain = breed + ' (M3)'
        url = uri + 'heifer-bulls'
      } else if (breed === 'Red Maternal') {
        breedStrain = breed + ' (M4)'
        url = uri + 'maternal-bulls?variant=5891835658283'
      } else if (breed === 'Terminal Cross') {
        breedStrain = breed + ' (TX)'
        url = uri + 'terminal-cross-bulls'
      }

      self.$confirm(
        '<h3>Reserve a ' + breedStrain + '</h3>', {
          color: 'orange darken-3',
          icon: 'help',
          title: 'Reserve?',
          width: 300,
          buttonTrueText: 'Yes, Reserve'
        }).then(res => {
        if (res) {
          self.confirmDialog = false
          window.open(url, '_blank')
        }
      })
    }
  }
}
</script>

<style scoped>
.v-input {
  line-height: 1em;
  margin: 0;
  padding: 0
}
.v-input-sm {
  font-size: .9em;
}

.v-input-md {
  font-size: 1em;
}
</style>
